import classNames from "classnames";
import styles from "./index.module.scss";

export interface FixDividerProps {
  vertical?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function FixDivider({ vertical = false, className, style }: FixDividerProps) {
  return (
    <div
      role="separator"
      aria-orientation={vertical ? "vertical" : "horizontal"}
      className={classNames(styles["fix-divider"], vertical ? styles["fix-divider-vertical"] : styles["fix-divider-horizontal"], className)}
      style={style}
    />
  );
}
